import React from "react";
import { Link } from "react-router-dom";

const AboutArea = () => {
  return (
    <section className="about--layout4 space shape-mockup-wrap">
      <div className="container">
        <div className="row align-items-center justify-content-between">
          <div className="col-xl-6">
            <div className="img-box4">
              <div className="img-box4__img1">
                <img
                  className="img1"
                  src="/img/home/about1.jpg"
                  alt="about imagee"
                />
              </div>
              <div className="img-box4__img2">
                <img
                  className="img2"
                  src="/img/home/about2.jpg"
                  alt="about imagee"
                />
                <img
                  className="img3"
                  src="/img/home/about3.jpg"
                  alt="about imagee"
                />
              </div>
              <div
                className="discount"
                style={{
                  backgroundImage: "url(/assets/img/shape/circle-shape.svg)",
                }}
              >
                <span>35%</span>
                <p>discount</p>
              </div>
            </div>
          </div>

          <div className="col-xl-6">
            <div className="about-content">
              <div className="title-area">
                <span className="sec-subtitle">Get to know us</span>
                <h2 className="sec-title h1">
                  Plan Your Next Stay with City Life Vacation Homes
                </h2>
                <p className="sec-text" style={{ textAlign: "justify" }}>
                  <b>City Life Vacation Homes Rental LLC</b> is a leading
                  provider of affordable and comfortable holiday home rental
                  services based in the heart of Deira, Dubai. We specialize in
                  offering short-term and long-term vacation accommodations
                  designed to meet the needs of travelers, business
                  professionals, and families seeking a home-away-from-home
                  experience.
                </p>

                <span className="sec-subtitle">
                  Experience Comfort, Convenience & Affordability
                </span>
              </div>

              <ul className="about-list2">
                <li>Comfortable, fully furnished apartments and villas</li>
                <li>Personalized services and 24/7 guest support</li>
                <li>
                  Prime locations close to major attractions and transport
                </li>
              </ul>

              <Link to="/about" className="vs-btn style5">
                About More
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutArea;
